import Button from '@mui/material/Button';
import React from "react";
import {useDispatch, connect} from 'react-redux';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Typography from "@mui/material/Typography";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';



const mapStateToProps = state => {
    return {
        map: state.MapReducer
    }
};

const LayerDataSelection = (props) => {
    let [value, setValue] = React.useState(props.map.activeLayer);

    React.useEffect(()=>{
        props.onLayerChange(`${value}`)
    }, [value])

    return <div style={{marginTop: 16}}>
        <Typography variant="caption" gutterBottom component="div">
            Topic
        </Typography>

        <Select style={{backgroundColor:'#ffffff'}}
            size='small'
            value={value}
            onChange={(e)=>{setValue(e.target.value)}}
        >
            {
                props.map.layerOptions.map(lo=>{
                    if(lo.layerId.includes("kulonb")||lo.layerId.includes("grid")) {
                    } else {
                        return <MenuItem key={lo.layerId} value={lo.layerId}>{lo.name}</MenuItem>
                    }
                })
            }
            <MenuItem key='grid' value='allum_project:1334_egesz_grid_sf'>Changes in development level (decile-values)</MenuItem>
        </Select>
    </div>
}

export default connect(mapStateToProps)(LayerDataSelection)